<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { useTranslation } from "i18next-vue";

import EditActivityGroupSettings from "@/components/activity-group/EditActivityGroupSettings.vue";

const { t } = useTranslation();

const props = defineProps({
  group_id: {
    type: String,
    required: true,
  },
});

</script>
<template>
  <Suspense>
    <div class="page-edit-activity-group">
      <div class="page-edit-activity-group__main">
        <EditActivityGroupSettings 
        :group-id="group_id"
        />
      </div>
    </div>
  </Suspense>
</template>
